<!--
 * @Description: 销售线索
 * @Author: mdb
 * @Date: 2022-07-06 11:24:43
 * @LastEditTime: 2023-06-21 09:13:27
 * @LastEditors: cxh
-->
<template>
  <dc-layout-main :is-breadcrumb="true">
    <dc-layout-content>
      <cos-table
        serial
        rowKey="clueId"
        :row-selection="{ onChange: onSelectRowsChange }"
        :columns="columns"
        v-model:search="queryForm"
        @fetch="getList"
        @mask="showMask"
        ref="tableRef"
        tableId="DcCosOFbuSalesClue"
      >
        <template #search>
          <a-form :model="queryForm">
            <dc-form-item :label="t('clue.clueStatus')">
              <a-radio-group v-model:value="queryForm.clueStatus" @change="handleQueryChange('search')">
                <a-radio-button v-for="item in clueStatusEnum" :key="item.value" :value="item.value">{{
                  t(item.lang)
                }}</a-radio-button>
              </a-radio-group>
            </dc-form-item>
            <dc-form-item :label="t('clue.clueType')">
              <CosSelect
                v-model:value="queryForm.clueTypeList"
                :options="clueTypeEnumComputed"
                :placeholder="t('common.pleaseSelect')"
                allowClear
                mode="multiple"
                max-tag-count="responsive"
                show-arrow
              />
            </dc-form-item>
            <dc-form-item :label="t('clue.notFollowDayNum')">
              <CosSelect
                v-model:value="queryForm.notFollowDayNumType"
                :options="customerUnfollowDayTypeEnum"
                :placeholder="t('common.pleaseSelect')"
                allowClear
              />
            </dc-form-item>
            <dc-form-item :label="t('common.createTime')">
              <CosRangePicker
                isOutputBeijingTime
                v-model:startTime="queryForm.startCreateTime"
                v-model:endTime="queryForm.endCreateTime"
              />
            </dc-form-item>
            <dc-form-item :label="t('clue.customerName')">
              <a-input
                v-model:value="queryForm.customerName"
                :maxlength="100"
                allowClear
                :placeholder="t('common.pleaseInput')"
              />
            </dc-form-item>
            <dc-form-item :label="t('common.contactMethod')">
              <a-input-group compact>
                <a-select
                  v-model:value="queryForm.contact.type"
                  style="width: 33%"
                  :placeholder="t('common.pleaseSelect')"
                >
                  <a-select-option :value="1">{{ t('common.mobile') }}</a-select-option>
                  <a-select-option :value="2">{{ t('common.email') }}</a-select-option>
                  <a-select-option :value="3">{{ t('common.skype') }}</a-select-option>
                </a-select>
                <a-input
                  v-model:value="queryForm.contact.keyword"
                  :maxlength="100"
                  style="width: 67%"
                  :placeholder="t('common.pleaseInput')"
                  allowClear
                />
              </a-input-group>
            </dc-form-item>
            <dc-form-item :label="t('clue.followerName')">
              <UserSelect v-model:value="queryForm.followerList" :placeholder="t('common.pleaseSelect')" allowClear mode="multiple"/>
            </dc-form-item>
            <dc-form-item :label="t('clue.clueId')">
              <a-input
                v-model:value="queryForm.clueId"
                :maxlength="100"
                allowClear
                :placeholder="t('common.pleaseInput')"
              />
            </dc-form-item>
            <dc-form-item :label="t('clue.receiveTime')">
              <CosRangePicker
                isOutputBeijingTime
                v-model:startTime="queryForm.startReceiveTime"
                v-model:endTime="queryForm.endReceiveTime"
              />
            </dc-form-item>
            <dc-form-item :label="t('clue.channel')">
              <a-input-group compact>
                <ParamCodeCascader
                  type="search"
                  v-model:ids="queryForm.channelList"
                  appId="cos_ofbu"
                  paramCode="ofbu_source_channel"
                  style="width: 33%"
                />
                <a-input
                  v-model:value="queryForm.channelExplain"
                  :maxlength="100"
                  style="width: 67%"
                  :placeholder="t('common.pleaseInput')"
                  allowClear
                />
              </a-input-group>
            </dc-form-item>
            <dc-form-item :label="t('clue.customerRegion')">
              <CustomerAreaCascader type="search" appId="cos_ofbu" v-model:ids="queryForm.customerRegionList" />
            </dc-form-item>
            <dc-form-item :label="t('clue.customerOffice')">
              <CosCascader
                v-model:value="queryForm.customerOffice"
                :options="customerAreaEnum"
                :fieldNames="{ label: 'name', value: 'id', children: 'children' }"
                :placeholder="t('common.pleaseSelect')"
                change-on-select
                allowClear
              />
            </dc-form-item>
            <dc-form-item name="activityQrcodeId" :label="t('clue.marketActivity')">
              <CosSelect
                  v-model:value="queryForm.activityQrcodeId"
                  :options="marketOptions"
                  :placeholder="t('common.pleaseSelect')"
                  allowClear
                  optionFilterProp="label"
                  showSearch
              />
            </dc-form-item>
          </a-form>
        </template>

        <template #button>
          <a-button v-permission="'ofbu_clue_add_btn'" type="primary" @click="triggerAddOrEdit()">{{
            t('btn.add')
          }}</a-button>
          <a-button v-permission="'ofbu_clue_person_btn'" @click="handleAssignPerson()">{{
            t('btn.personClue')
          }}</a-button>
          <ImportBtn
            v-permission="'ofbu_clue_import_btn'"
            action="/ofbu/api/clue/import"
            templateUrl="/ofbu/api/clue/template/download"
            @success="handleQueryChange('search')"
            >{{ t('btn.import') }}</ImportBtn
          >
          <ExportButton v-permission="'ofbu_clue_export_btn'" appId="cos_ofbu" taskType="401" :search="queryForm">{{
            t('btn.export')
          }}</ExportButton>
          <a-button v-permission="'ofbu_clue_merge_btn'" @click="handleClueMarge()">{{ t('btn.merge') }}</a-button>
          <a-button v-permission="'ofbu_clue_back_btn'" @click="handleSendBack()">{{ t('btn.returnBack') }}</a-button>
          <a-button v-permission="'ofbu_clue_valid_btn'" @click="handleBecomeValid()">{{
            t('btn.applyValid')
          }}</a-button>
          <a-button v-permission="'ofbu_clue_invalid_btn'" @click="handleBecomeInvalid()">{{
            t('btn.invalidate')
          }}</a-button>
          <a-button v-permission="'ofbu_clue_del_btn'" danger @click="handleDelete()">{{ t('btn.del') }}</a-button>
        </template>

        <template #bodyCell="{ column, record, text }">
          <template v-if="column.dataIndex === 'customerName'">
            <div class="flex">
              <p class="new-list-flag" v-if="record.clueStatus !== 8 && record.hasFollow === false">New</p>
              <router-link
                class="ant-table-cell-ellipsis"
                :to="`/ofbu/salesClue/view?clueId=${record.clueId}`"
                :title="text"
                >{{ text || '--' }}</router-link
              >
            </div>
          </template>
          <template v-if="column.dataIndex === 'channel'">
            <ChannelText appId="cos_ofbu" paramCode="ofbu_source_channel" :value="text" :desc="record.channelExplain" />
          </template>
          <template v-if="column.dataIndex === 'customerRegion'">
            <CustomerAreaCascaderText appId="cos_ofbu" :value="text" />
          </template>
          <template v-if="column.dataIndex === 'clueStatus'">
            <dc-status :enums="statusEnum" :value="text" />
          </template>
          <template v-if="column.dataIndex === 'customerOffice'">
            <CustomerArea type="text" :value="text" />
          </template>
          <template v-if="column.dataIndex === 'followDesc'">
            <EditorTableText :value="text" />
          </template>
          <template v-if="column.dataIndex === 'action'">
            <MoreButton>
<!--              <SellerButton-->
<!--                v-permission="'ofbu_new_client_evaluation_add_btn'"-->
<!--                type="link"-->
<!--                :workCode="record.follower"-->
<!--                :disabled="record.clueStatus === 8"-->
<!--                @click="handleNewClientEvaluation(record)"-->
<!--                >{{ t('btn.newClientEvaluation') }}</SellerButton-->
<!--              >-->
<!--              <SellerButton-->
<!--                v-permission="'ofbu_new_client_evaluation_add_btn'"-->
<!--                type="link"-->
<!--                :workCode="record.follower"-->
<!--                :disabled="record.clueStatus === 8"-->
<!--                @click="handleNewClientEvaluation(record, false)"-->
<!--                >{{ t('btn.newClientEvaluationNotApprove') }}</SellerButton-->
<!--              >-->
              <!-- 已转化的线索或者暂未转换但是审核状态有审核中或审核通过流程的客户不能再发起 -->
              <SellerButton
                type="link"
                v-permission="'ofbu_new_client_evaluation_add_btn'"
                :disabled="record.clueStatus === 8 || record.oaAuditStatus === '20' || record.oaAuditStatus === '30'"
                @click="handleNewClientEvaluation(record, false)"
                >{{ t('btn.newClientEvaluation') }}</SellerButton
              >
              <SellerButton
                type="link"
                v-permission="'ofbu_to_potential_account_btn'"
                :disabled="record.clueStatus === 8 || record.oaAuditStatus === '20' || record.oaAuditStatus === '30'"
                @click="handleNewClientEvaluation(record)"
                >{{ t('btn.toPotentialAccount') }}</SellerButton
              >
              <a-button
                v-permission="'ofbu_clue_write_follow_btn'"
                type="link"
                :disabled="record.clueStatus === 8"
                @click="handleWriteFollowUp(record.clueId)"
                >{{ t('btn.writeFollow') }}</a-button
              >
              <SellerButton
                v-permission="'ofbu_clue_edit_btn'"
                type="link"
                :disabled="record.clueStatus === 8"
                @click="triggerAddOrEdit(record.clueId)"
                >{{ t('btn.edit') }}</SellerButton
              >

              <SellerButton
                v-permission="'ofbu_clue_invalid_btn'"
                type="link"
                :workCode="record.follower"
                :disabled="record.clueStatus === 8"
                @click="handleBecomeInvalid(record)"
                >{{ t('btn.invalidate') }}</SellerButton
              >
              <a-button
                v-permission="'ofbu_clue_del_btn'"
                type="link"
                :disabled="record.clueStatus === 8"
                @click="handleDelete(record)"
                >{{ t('btn.del') }}</a-button
              >
            </MoreButton>
          </template>
        </template>
      </cos-table>
    </dc-layout-content>
  </dc-layout-main>

  <!-- 申请转有效线索弹窗 -->
  <BecomeValid ref="becomeValidRef" @fetch="handleQueryChange('fetch')" />

  <!-- 分配客户负责人弹窗 -->
  <ClueAssign ref="clueAssignRef" @fetch="handleQueryChange('fetch')" />

  <!-- 线索合并弹窗 -->
  <ClueMarge ref="clueMargeRef" @fetch="deleteRefresh(1)" />

  <!-- 置为无效线索弹窗 -->
  <BecomeInvalid ref="becomeInvalidRef" @fetch="handleQueryChange('fetch')" />
</template>

<script setup lang="ts">
import { ref, reactive, computed, onMounted, toRaw } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { message } from '@dc-platform/dc-components'
import ParamCodeCascader from '@/components/CosCascader/components/ParamCodeCascader.vue'
import ChannelText from '@/components/CosCascaderText/components/channel.vue'
import Modal from '@/hooks/modalType'
import ImportBtn from '@/components/ImportBtn'
import ClueAssign from '../components/ClueAssign.vue'
import BecomeValid from './components/BecomeValid.vue'
import BecomeInvalid from './components/BecomeInvalid.vue'
import ClueMarge from './components/ClueMarge.vue'
import CustomerArea from '@/components/CustomerArea'
import EditorTableText from '@/components/Editor/src/tableText.vue'
import CustomerAreaCascader from '@/components/CustomerAreaCascader/index.vue'
import CustomerAreaCascaderText from '@/components/CustomerAreaCascader/CustomerAreaCascaderText.vue'
import { listByParamCodes, adminArea } from '@/api/common'
import { customerUnfollowDayTypeEnum, genderEnum, linkRoleTypeEnum } from '@/views/overseasSales/commonEnum/dataConfig'
import { clueStatusEnum, clueTypeEnum } from '../dataConfig'
import { salesClueList, salesClueRefund, salesClueDelete, salesClueDetail } from '@/api/overseasSales/clueManage'
import type { ParamCodeItem } from '@/typings/common'
import type { SalesClueParams, SalesClueListItem } from '@/typings/api/clueManage'
import { useI18n } from 'vue-i18n'
import { cloneDeep } from 'lodash-es'
import { queryMarketActivityList } from '@/api/marketing/marketingManage'
import CosSelect from '@/components/Antd/CosSelect/index.vue'
const { t } = useI18n()
const router = useRouter()
const route = useRoute()

// 线索类型枚举列表
const clueTypeEnumComputed = computed(() => clueTypeEnum.filter((item) => item.value !== 0))
const statusEnum = computed(() =>
  clueStatusEnum.map((item) => ({
    name: t(item.lang),
    value: item.value,
    color: item.color
  }))
)
// 业务参数
const paramCodeData = ref<{
  ofbu_source_channel: ParamCodeItem[]
}>({
  ofbu_source_channel: [] // 客户来源
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_ofbu',
    paramCodes: ['ofbu_source_channel']
  }).then((res) => {
    paramCodeData.value = res.data
  })
}
const marketOptions = ref<any[]>([])
const getMarketOption = () => {
  queryMarketActivityList({ subdomain: 'cos_ofbu' }).then((res) => {
    if (res.data && res.data.length) {
      marketOptions.value = res.data.map((item: any) => ({
        label: item.activityName,
        value: item.id
      }))
    }
  })
}
onMounted(() => {
  getByParamCodes()
  getMarketOption()
})
// 获取办公地省市区数据
const customerAreaEnum = ref<any[]>([])
const getAdminArea = () => {
  const params = { appId: 'cos_ofbu' }
  adminArea(params).then((res) => {
    customerAreaEnum.value = res.data
  })
}
// 获取详情联系人信息
const showMask = (record: SalesClueListItem, callBack: (res: any) => void) => {
  salesClueDetail({ clueId: record.clueId }).then((res) => {
    const { contact } = res.data
    callBack(contact)
  })
}
onMounted(() => {
  getAdminArea()
})

const tableRef = ref()
const queryForm = reactive<SalesClueParams>({ contact: { type: 1 }, channelList: route.query.channelId ? [Number(route.query.channelId)] : [], channelExplain: route.query.channelExplain || '' })
const columns = computed(() => [
  {
    title: t('clue.customerName'),
    dataIndex: 'customerName',
    fixed: 'left',
    width: 200
  },
  { title: t('clue.clueId'), dataIndex: 'clueId', width: 200 },
  { title: t('clue.clueChannel'), dataIndex: 'channel', width: 150 },
  { title: t('clue.clueType'), dataIndex: 'clueType', dicData: clueTypeEnum },
  { title: t('clue.clueStatus'), dataIndex: 'clueStatus' },
  { title: t('clue.customerRegion'), dataIndex: 'customerRegion' },
  { title: t('clue.followerName'), dataIndex: 'followerName' },
  { title: t('clue.beforeFollowerName'), dataIndex: 'beforeFollowerName' },
  { title: t('clue.notFollowDayNum'), dataIndex: 'notFollowDayNum' },
  { title: t('clue.customerOffice'), dataIndex: 'customerOffice' },
  { title: t('clue.marketActivity'), dataIndex: 'activityQrcodeId', dicData: marketOptions.value },
  { title: t('clue.followDesc'), dataIndex: 'followDesc' },
  { title: t('common.contactName'), dataIndex: ['contact', 'name'], cosType: 'mask' },
  { title: t('common.mobile'), dataIndex: ['contact', 'mobile'], cosType: 'mask' },
  { title: t('common.skype'), dataIndex: ['contact', 'skype'], cosType: 'mask' },
  { title: t('common.email'), dataIndex: ['contact', 'email'], cosType: 'mask' },
  { title: t('common.sex'), dataIndex: ['contact', 'sex'], dicData: genderEnum },
  { title: t('common.jobRole'), dataIndex: ['contact', 'jobRole'], dicData: linkRoleTypeEnum },
  { title: t('common.jobDuty'), dataIndex: ['contact', 'jobDuty'] },
  { title: t('common.createTime'), dataIndex: 'createTime', width: 190 },
  { title: t('clue.firstReceiveTime'), dataIndex: 'firstReceiveTime', width: 190 },
  { title: t('clue.lastReceiveTime'), dataIndex: 'lastReceiveTime', width: 190 },
  { title: t('custom.stageChangeTime'), dataIndex: 'stageChangeTime', width: 190 },
  { title: t('common.remark'), dataIndex: 'remark' },
  {
    title: t('common.action'),
    dataIndex: 'action',
    langWidth: {
      zh: 360,
      en: 380
    },
    fixed: 'right'
  }
])
const getList = (queryForm: SalesClueParams, callBack: (res: any) => void) => {
  const params = cloneDeep(queryForm)
  const clueIds = params.clueId?.split(/[,，\s\n]/).filter((e: string) => e)
  if (clueIds && clueIds.length > 1) {
    params.clueIdList = clueIds
    delete params.clueId
  }
  salesClueList(params).then((res) => {
    callBack(res)
  })
}
const handleQueryChange = (type: 'search' | 'fetch') => {
  if (type === 'search') {
    tableRef.value?.search()
  } else {
    tableRef.value?.fetch()
  }
}
const deleteRefresh = (num: number) => {
  const params = toRaw(selectedData.value)
  params.splice(0, num)
  tableRef.value?.delFetch(params, 'clueId')
}

const selectedData = ref<SalesClueListItem[]>([])
const onSelectRowsChange = (selectedRowKeys: string[], selectedRows: SalesClueListItem[]) => {
  selectedData.value = selectedRows
}

// 退回线索
const handleSendBack = () => {
  if (selectedData.value.length === 0) return message.warning(t('tips.XviYDSD'))
  const params = {
    clueIdList: selectedData.value.map((item: SalesClueListItem) => item.clueId)
  }
  salesClueRefund(params).then(() => {
    message.success(t('tips.returnSuccess'))
    handleQueryChange('fetch')
  })
}

// 申请转有效线索
const becomeValidRef = ref()
const handleBecomeValid = () => {
  if (!selectedData.value.length) return message.warning(t('tips.lqxmibH4lN'))
  const hasValid = selectedData.value.some((item: SalesClueListItem) => item.clueType !== 3)
  if (hasValid) return message.warning(t('tips.WdKeuH'))
  becomeValidRef.value?.init(toRaw(selectedData.value))
}

// 置为无效线索
const becomeInvalidRef = ref()
const handleBecomeInvalid = (row?: SalesClueListItem) => {
  if (!row && !selectedData.value?.length) return message.warning(t('tips.He2i7afS9'))
  const paramsRow = row ? [row] : toRaw(selectedData.value)
  becomeInvalidRef.value?.init(paramsRow)
}

// 新增编辑函数
const triggerAddOrEdit = (clueId?: string, isPerfect?: string) => {
  if (clueId) {
    router.push({ path: '/ofbu/salesClue/edit', query: { clueId, isPerfect } })
  } else {
    router.push('/ofbu/salesClue/add')
  }
}
// 跳转写跟进页面
const handleWriteFollowUp = (clueId: string) => {
  router.push({
    path: '/ofbu/followUpRecord/add',
    query: { followRefId: clueId, returnPath: route.fullPath }
  })
}
// 分配客户负责人
const clueAssignRef = ref()
const handleAssignPerson = () => {
  if (!selectedData.value.length) return message.warning(t('tips.WJ6P9i7'))
  clueAssignRef.value?.init(toRaw(selectedData.value))
}

// 合并线索
const clueMargeRef = ref()
const handleClueMarge = () => {
  if (selectedData.value.length < 2) return message.warning(t('tips.VLM7eZ0'))
  clueMargeRef.value?.init(toRaw(selectedData.value))
}

// 新客评审
const handleNewClientEvaluation = (row?: SalesClueListItem, toPotential = true) => {
  if (!row) return
  if (row.clueType === 3) return message.warning(t('tips.newClientEvaTips'))
  router.push({ path: '/ofbu/newClientEvaluation/add', query: { clueId: row.clueId, toPotential: toPotential ? '1' : undefined } })
}
const handleDelete = (row?: SalesClueListItem) => {
  if (!row && !selectedData.value?.length) {
    return message.error(t('tips.MJY7jfnR'))
  }
  const clueIdList: any[] = []
  const customerName = []
  if (row) {
    clueIdList.push(row.clueId)
    customerName.push(row.customerName)
  } else {
    selectedData.value?.forEach((item) => {
      clueIdList.push(item.clueId)
      customerName.push(item.customerName)
    })
  }
  const customerNameTxt = customerName.join(',')
  Modal.delete({
    content: t('custom.CUn3xat3', { customerName: customerNameTxt }),
    onOk() {
      salesClueDelete({ clueIdList }).then(() => {
        message.success(t('tips.delCluetSuccess'))
        deleteRefresh(0)
      })
    }
  })
}
</script>
<script lang="ts">
export default { name: 'DcCosOFbuSalesClue' }
</script>

<style scoped></style>
